export default "__VITE_ASSET__CHCcNyto__"